<template>
    <div>
        <section class="tab">
            <ul class="nav nav-tabs justify-content-around">
                <li class="nav-item" v-for="tab in tabs">
                    <a class="nav-link" :class="{ 'active': tab.id === tabIndex }" :href='`#tab-${tab.id}`'
                       data-toggle="tab" @click="switchTab(tab.id)">{{ characters[tab.type+'_type'] }}</a>
                </li>
            </ul>

            <div class="tab-content">
                <div id="tab-0" class="tab-pane active">
                    <div class="discography-item screen-transition" v-for="discography in discography_list" @click="show_detail(discography.id)">
                        <article>
                            <div class="thumb">
                                <p class="img">
                                    <img :src="'/discography/image/'+discography.id" :alt="discography.title">
                                </p>
                            </div>
                            <div class="cmnt">
                                <div class="data flex">
                                    <p class="tag">{{ characters[discography.category+'_type'] }}</p>
                                    <p class="date fnt-cg">{{ discography.date}}</p>
                                </div>
                                <p class="post-title">{{ discography.title }}</p>
                            </div>
                        </article>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: "discography",
        props: ['default_type', 'tab_list_bit', 'json_characters'],
        data: function () {
            return {
                tabIndex: null,
                count: 0,
                tabs: [],
                tab_origin: [
                    {id: 0, title: '全て', type: 'all'},
                    {id: 1, title: 'アルバム', type: 'ALBUM'},
                    {id: 2, title: 'シングル', type: 'SINGLE'},
                    {id: 3, title: 'ビデオ', type: 'DVD'},
                ],
                discography_list: [],
                characters: Object,
            }
        },
        mounted() {
            this.setTab();
            let tabIndex = this.getTabType(this.default_type)
            if(tabIndex !== null) {
                localStorage.setItem('discography-tabIndex', tabIndex);
            }
            if (localStorage.getItem('discography-tabIndex') === null) {
                tabIndex = 0;
            } else {
                tabIndex = Number(localStorage.getItem('discography-tabIndex'));
            }
            this.tabIndex = tabIndex;
            this.characters = JSON.parse(this.json_characters);
        },
        methods: {
            switchTab: function (id) {
                this.tabIndex = id;
            },
            show_detail: function (id) {
                location.href = "/discography/detail/"+id;
            },
            getTabType: function(type) {
                const tab = this.tabs.find(element => element.type === type);
                if(tab) {
                    // console.log(tab);
                    return tab.id;
                }
                return null;
            },
            searchItem: function(type) {
                const query = type?'?category='+type:'';
                axios.default
                    .get('/discography/list' + query)
                    .then(response => {
                        this.discography_list = response.data;
                    });
            },
            getTypeByIndex: function(index) {
                let type = '';
                switch (index) {
                    case 0:
                        type = '';
                        break;
                    case 1:
                        type = 'ALBUM';
                        break;
                    case 2:
                        type = 'SINGLE';
                        break;
                    case 3:
                        type = 'DVD';
                        break;
                }
                return type;
            },
            setTab: function() {
                for(let i=0; i<this.tab_origin.length; i++) {
                    if(this.tab_list_bit & 2**i) {
                        this.tabs.push(this.tab_origin[i]);
                    }
                }
            },
        },
        watch: {
            tabIndex: function (newIndex, oldIndex) {
                localStorage.setItem('discography-tabIndex', newIndex);
                let type = this.getTypeByIndex(newIndex);
                this.searchItem(type);
            },
        }
    }
</script>

<style scoped>
</style>
